import { render } from "./Callback.vue?vue&type=template&id=37065118&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"

import "./Callback.vue?vue&type=style&index=0&id=37065118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37065118"]])

export default __exports__